import {
  STRIPE_PUBLIC_KEY,
  STRIPE_SEMIANNUAL_PRICE_ID,
  STRIPE_ANNUAL_PRICE_ID,
  STRIPE_SEMIANNUAL_PRODUCT_ID,
  STRIPE_ANNUAL_PRODUCT_ID,
} from "./env";

import {
  getProductById,
  getPriceById,
  formatPrice,
  getBillingInterval,
  StripeProduct,
  StripePrice,
} from "@/services/stripe";

// Get price and product information from the Stripe service
const getSemiannualPrice = (): StripePrice | null =>
  getPriceById(STRIPE_SEMIANNUAL_PRICE_ID);
const getAnnualPrice = (): StripePrice | null =>
  getPriceById(STRIPE_ANNUAL_PRICE_ID);
const getSemiannualProduct = (): StripeProduct | null =>
  getProductById(STRIPE_SEMIANNUAL_PRODUCT_ID);
const getAnnualProduct = (): StripeProduct | null =>
  getProductById(STRIPE_ANNUAL_PRODUCT_ID);

// Stripe Plans Configuration with dynamic lookup
export const PLANS = {
  SEMIANNUAL: {
    name: getSemiannualProduct()?.name || "Personal 6-Month Plan",
    price: getSemiannualPrice()?.unitAmount
      ? getSemiannualPrice()!.unitAmount / 100
      : 29.99,
    formattedPrice: getSemiannualPrice()
      ? formatPrice(getSemiannualPrice()!)
      : "$29.99",
    billingInterval: getSemiannualPrice()
      ? getBillingInterval(getSemiannualPrice()!)
      : "every 6 months",
    id: STRIPE_SEMIANNUAL_PRICE_ID,
    productId: STRIPE_SEMIANNUAL_PRODUCT_ID,
    features: [
      "10 pets",
      "1GB document storage",
      "Advanced reminders",
      "Veterinarian sharing",
      "Medication tracking",
      "Health trend analytics",
    ],
  },
  YEARLY: {
    name: getAnnualProduct()?.name || "Personal Annual Plan",
    price: getAnnualPrice()?.unitAmount
      ? getAnnualPrice()!.unitAmount / 100
      : 39.99,
    formattedPrice: getAnnualPrice()
      ? formatPrice(getAnnualPrice()!)
      : "$39.99",
    billingInterval: getAnnualPrice()
      ? getBillingInterval(getAnnualPrice()!)
      : "per year",
    id: STRIPE_ANNUAL_PRICE_ID,
    productId: STRIPE_ANNUAL_PRODUCT_ID,
    features: [
      "10 pets",
      "1GB document storage",
      "Advanced reminders",
      "Veterinarian sharing",
      "Medication tracking",
      "Health trend analytics",
      "Priority support",
      "2 months free",
    ],
  },
};

// Re-export from env.ts for backward compatibility
export {
  STRIPE_PUBLIC_KEY as STRIPE_PUBLISHABLE_KEY,
  STRIPE_SEMIANNUAL_PRICE_ID,
  STRIPE_ANNUAL_PRICE_ID,
  STRIPE_SEMIANNUAL_PRODUCT_ID,
  STRIPE_ANNUAL_PRODUCT_ID,
};

// Export Stripe service functions for use elsewhere
export { getProductById, getPriceById, formatPrice, getBillingInterval };
